import { render, staticRenderFns } from "./PeriodicalModification.vue?vue&type=template&id=58d4eb67&scoped=true"
import script from "./PeriodicalModification.vue?vue&type=script&lang=js"
export * from "./PeriodicalModification.vue?vue&type=script&lang=js"
import style0 from "./PeriodicalModification.vue?vue&type=style&index=0&id=58d4eb67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d4eb67",
  null
  
)

export default component.exports